import { Controller } from 'lib_ts/enums/routing/controllers';
import { TrainingLogsRoutes } from 'lib_ts/enums/routing/routes/training-logs';
import { DictOf } from 'lib_ts/interfaces/common/i-dictionary';
import { ForUpdate } from 'lib_ts/interfaces/common/i-generics';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  ITrainingLog,
  ITrainingLogExt,
  ITrainingLogSummary,
  ITrainingPerformanceFilters,
} from 'lib_ts/interfaces/training/i-training-log';
import { BaseRESTService } from 'services/_base-rest.service';

export class TrainingLogsService extends BaseRESTService {
  private static instance: TrainingLogsService;
  static getInstance(): TrainingLogsService {
    if (!TrainingLogsService.instance) {
      TrainingLogsService.instance = new TrainingLogsService();
    }

    return TrainingLogsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.TrainingLogs,
    });
  }

  createOne(model: Partial<ITrainingLog>) {
    return this.post(
      {
        uri: TrainingLogsRoutes.CreateOne,
      },
      model
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to create training log');
          return undefined;
        }

        return result.data as ITrainingLog;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  deleteOne(id: string) {
    return this.delete({
      uri: `${TrainingLogsRoutes.DeleteOne}/${id}`,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to delete training log');
        }

        return result.success;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }

  updateOne(model: ForUpdate<ITrainingLog>) {
    return this.put(
      {
        uri: `${TrainingLogsRoutes.UpdateOne}/${model._id}`,
      },
      model
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to update training log');
          return undefined;
        }

        return result.data as ITrainingLog;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  // { [machineID]: ITrainingLog }
  summarize() {
    return this.get({
      uri: TrainingLogsRoutes.Summarize,
    })
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to summarize training logs');
          return undefined;
        }

        return result.data as DictOf<ITrainingLogSummary>;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  search(filter: ITrainingPerformanceFilters) {
    return this.post(
      {
        uri: TrainingLogsRoutes.Search,
      },
      filter
    )
      .then((result: IServerResponse) => {
        if (!result.success) {
          console.error(result.error ?? 'Failed to search training logs');
          return undefined;
        }

        return result.data as ITrainingLogExt[];
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
